export default {
  data() {
    return {
      formStatsUser: {
        act: false, // critical active user (basic.act copy)
        tag: "U1",
        admin: false, // admin user settiings
        ahold: false, // user is on holder from Admin for Comp or Facility
        alock: false, // user is locked admin
        alockc: false, // company access locked by Company custodnian
        alockcdid: "", // locked company cdid
        alockct: "", // locked company title, last lock
        alockf: false, // facility lock by custodian
        alockfdid: "", // locked company facility, last lock
        alockft: "", //  lock facility title
        areset: false, // info reset
        averify: "", // level of verificaton for user (email / identify / skill)
        aip: "", // last ip address
        adev: "", // last device used at login
        aloc: "", // loast location used at login
        rlic: "Free", // type of licence
        dcrt: "", // date created
        dchk: "", // date check / last time use was checked against server stats
        dlog: "", // last log date
        drev: "", // next review date (for critical documents)
        dedit: "",
        dopen: "", // document opened
        dsin: "", // sign in
        dsout: "", // sign out
        dsingeo: "", // location
        dsoutgeo: "", // location
        dsindev: "", // device
        dsoutdev: "", // devince
        dexp: "", // when licence expires and unable to process
        dhold: "", // when hold due to what ever
        dpass: "", // last time passward was changed
        n: 0, // primary counter
        nread: 0, // reads
        nwrite: 0, // number of writes
        ndel: 0, // number of deletes
        ncom: 0, // number of comments
        npass: 0, // number of times passward was chnaged
        na1: 0, // counter asset
        nc1: 0, // counter company
        nc1a: 0, // number of companies accessed
        nb1: 0, // counter risk
        nb3: 0, // counter actions
        nb3o: 0, // counter open actions that need attention
        nb4: 0, // counter budget
        nb6: 0, // counter plan
        nd3: 0, // counter document log
        nd3u: 0, // unread logs
        nd3a: 0, // logs that need attention
        nd4: 0, // attachments
        nk4: 0, // imported relelationships counters
        ne1: 0, // counter equipment
        ne2: 0, // counter engineering
        ne6: 0, // program (test and inspection)
        nf1: 0, // counter facility
        nf1a: 0, // number of facilities accessed
        nh1: 0, // skills
        nh2: 0, // competencies
        nh3: 0, // certificate
        nh4: 0, // licence
        nl1: 0, // counter materials
        no1: 0, // counter operations
        nq1: 0, // counter orders
        nm2: 0, // counter maintenance startgies
        nm5: 0, // counter maintenance plans
        ns1: 0, // counter hazard
        ns6: 0, // counter incident
        nw1: 0, // counter work request
        nw2: 0, // counter work calls
        nw6: 0, // procedures
        nlogin: 0, // number of logins simulntanous
        nrate: 0 // rate user with certain value, based on skills
      },
      formStatsCompany: {
        tag: "C1",
        dcrt: "", // date creater
        dlog: "", // last log date
        drev: "", // next review date (for critical documents)
        dedit: "", // last edit
        dopen: "", // document opened last time
        n: 0, // primary counter
        nread: 0, // number of reads
        nrate: 0, // rating
        nrisk: 0, // total risk value
        nlike: 0, // likes
        na1: 0, // accumultive assesst for all facilities
        nb1: 0, // risk
        nb3: 0, // actions
        nb3o: 0, // actions open
        nb4: 0, // budget
        nb4o: 0, // budget open
        nb6: 0, // plan
        nb6o: 0, // plan open
        ne2: 0, // engineerin
        ne2o: 0, // engineerin open
        nk4: 0, // relelationships
        nd3: 0, // document log
        nd3u: 0, // unread logs
        nd3a: 0, // logs that need attention
        nd4: 0, // attachments
        ng4: 1, // roles
        ne1: 0, // equipment
        ne6: 0, // inspection and test programs templates
        nf1: 0, // number of facilities
        nl1: 0, // materials
        nq1: 0, // orders
        nq1o: 0, // orders open
        nm2: 0, // maintenance startgies
        ns1: 0, // hazards
        ns6: 0, // incidents
        ns6o: 0, // incidents open
        nu1: 1, // first user when creating
        nw6: 0 // procedudrues templates for jobs
      },
      formStatsFacility: {
        tag: "F1",
        dcrt: "",
        dlog: "", // last log date
        dedit: "",
        drev: "", // next review date (for critical documents)
        nread: 0, // number of documents read
        nrisk: 0, // total risk value
        nrate: 0,
        dopen: "", // document opened
        n: 0, // primary counter
        nd3: 0, // counter document log
        nd3u: 0, // unread logs
        nd3a: 0, // logs that need attention
        nd4: 0, // number of attachments
        ng4: 0, // roles
        nk4: 0, // imported relelationships counters
        na1: 0, // counter asset
        ne2: 0, // counter engineering
        ne2o: 0, // counter engineering open
        no1: 0, // operation notifications
        no1o: 0, // operations notifications open
        nm5: 0, // counter maintenance plans
        nm7: 0, // counter maintenance plans
        ns1: 0, // hazards register
        ns2: 0, // risk assessment list
        ns3: 0, // barriers array
        ns4: 0, // controls array
        ns5: 0, // outcomes array
        nu1: 0, // number of users
        nw1: 0, // counter work request
        nw1o: 0, // counter work request open
        nw2: 0, // counter work calls
        nw2o: 0 // counter work request open
      },
      formStatsAsset: {
        dcrt: "",
        dlog: "", // last log date
        dedit: "",
        n: 0, // primary counter
        nread: 0, // number of documents read
        nrisk: 0, // total risk value
        nrate: 0,
        na1: 0, // number of children assets
        nd4: 0, // number of attachments
        nd3: 0, // counter document log
        nd3u: 0, // unread logs
        nd3a: 0, // logs that need attention
        nk4: 0, // imported relelationships counters
        nl1: 0, // bill if materials (BOM), register of materials
        ne2: 0, // counter engineering
        no1: 0, // counter operations notifications
        nm5: 0, // counter maintenance plans
        ns6: 0, // counter number of incidents againts this asset
        nw1: 0, // counter work request for repair
        nw2: 0 // counter work calls for work calls
      },
      formStatsItem: {
        dcrt: "", // when created
        dedit: "", // last mod
        nedit: 0, // number of edits
        n: 0, // main counter
        nctr: 0, // genera counter, counter of maintenance plans generated
        udid: "", // user did
        upos: "", // user position
        uname: "", // user name / title
        uemail: "", // user email,
        uauth: "",
        uadmin: false
      },
      formStatsMaintActivity: {
        dcrt: "", // when created
        dedit: "", // last mod
        nedit: 0, // number of edits
        n: 0, // main counter
        nm5: 0, // maintence plans generated
        nctr: 0, // genera counter, counter of maintenance plans generated
        udid: "", // user did
        upos: "", // user position
        uname: "", // user name / title
        uemail: "", // user email,
        uauth: "",
        uadmin: false
      },
      formStatsWork: {
        dcrt: "", // last created modified
        dedit: "", // last edited
        drev: "", // next review date (for critical documents)
        ddue: "",
        nread: "",
        dcomp: "",
        dplan: "",
        dstr: "",
        dend: "",
        n: 0, // primary counter
        ndue: 0, // number of due date changes
        nedit: 0, // number if edits
        nk4: 0, // imported relelationships counters
        ng4: 0, // number of unqiue roles
        nl5: 0,
        nh5: 0,
        no5: 0,
        ne5: 0, // results
        nw5: 0,
        nw6: 0, // number of procedure steps
        nb3: 0, // actions
        nd4: 0, // number of attachments
        ntrans: 0,
        nq1: 0, // number of orders parts
        nven: 0,
        nvenc: 0, // number of vendors mobilised
        ns1: 0,
        ns3: 0,
        ns4: 0,
        ns5: 0,
        uname: "", // first name and last name
        uemail: "",
        udid: "", // user did option
        upos: "", // user position
        ucom: "", // user comment
        uauth: "Org" // User author type, origninator is defaul
      },
      formStatsSimple: {
        dcrt: "", // date createed
        dedit: "", // last edit
        drev: "", // next review date (for critical documents)
        ddue: "", // next due date (for critical documents)
        n: 0, // primary counter
        nctr: 0, // general counter
        nd4: 0, // number of attachments
        nk4: 0, // imported relelationships counters
        ng4: 0 // number of roles
      },
      formStatsNotification: {
        dcrt: "", // date createed
        dedit: "", // last edit
        dopen: "", // last time document was opened
        n: 0, // primary counter
        nlike: 0, // number of likes or confirmatios
        nread: 0, // number of read counter
        nwork: 0, // number of work orders generated
        nctr: 0, // general counter
        nd4: 0, // number of attachments
        nk4: 0 // imported relelationships counters
      },
      formStatsOrder: {
        dcrt: "", // date createed
        dedit: "", // last edit
        drev: "", // next review date (for critical documents)
        ddue: "", // next due date (for critical documents)
        deta: "", // eta date
        dmob: "",
        demob: "",
        n: 0, // primary counter
        nctr: 0, // general counter
        nb3: 0, // number of actions
        nb3o: 0, // number of axctions open
        nd4: 0, // number of attachments
        nk4: 0, // imported relelationships counters
        ng4: 0 // number of roles
      },
      formStatsIncidentRisk: {
        dcrt: "", // date createed
        dedit: "", // last edit
        devent: "", // event date
        drev: "", // next review date (for critical documents)
        n: 0, // primary counter
        nctr: 0, // general counter
        nb3: 0, // number of actions
        nd4: 0, // number of attachments
        nk4: 0, // imported relelationships counters
        ng4: 3, // number of roles (initally 3)
        ns1: 0, // hazards register
        ns2: 0, // risk assessment list
        ns3: 0, // barriers array
        ns4: 0, // controls array
        ns5: 0, // outcomes array
        ns7: 0 // causes array
      },
      formStatsEngineering: {
        dcrt: "", // date createed
        dedit: "", // last edit
        dstr: "", // event date
        dend: "", // event date
        ddue: "", // due date when to complete engineering
        drev: "", // next review date (for critical documents)
        n: 0, // primary counter
        nctr: 0, // general counter
        nb3: 0, // number of actions
        nd4: 0, // number of attachments
        nk4: 0, // imported relelationships counters
        ng4: 3, // number of roles (initally 3)
        ns2: 0 // risk assessment list
      },
      formStatsReport: {
        dcrt: "", // date createed (document created)
        dedit: "", // last edit
        dtest: "", // test date (when inspection / tets was genaretd)
        dapp: "", // date approved and published
        n: 0, // primary counter
        nctr: 0, // general counter
        nd4: 0, // number of attachments to support results
        ne5: 0, // results to support
        nk4: 0 // imported relelationships counters
      },
      formStatsAction: {
        dcrt: "", // date createed
        dedit: "", // last edit
        ddue: "", // due date date
        dcont: "", // risk control date
        n: 0, // primary counter
        ndue: 0, // number of due date changes
        ncont: 0, // number of riks control chnages
        nctr: 0, // general counter
        nd4: 0, // number of attachments
        nk4: 0, // imported relelationships counters
        ng4: 2 // number of roles (initally 2 = doer and supervisor)
      },
      formStatsHazard: {
        dcrt: "", // date createed
        dedit: "", // last edit
        drev: "", // next review date (for critical documents)
        n: 0, // primary counter
        nctr: 0, // general counter
        nread: 0, // number of documents read
        ndue: 0, // number of due date chnages
        nd4: 0, // number of attachments
        nk4: 0, // imported relelationships counters
        ng4: 1, // number of roles (initial roles)
        ns3: 0, // list of barrier
        ns4: 0 // list of controls
      },
      formStatsEquipment: {
        dcrt: "", // date createed
        dedit: "", // last edit
        drev: "", // next review date (for critical documents)
        n: 0, // primary counter
        nctr: 0, // general counter
        nread: 0, // number of documents read
        nd4: 0, // number of attachments
        ne3: 0, // number of technical analysis
        ng4: 0, // custondian for this equipment
        nk4: 0 // imported relelationships counters
      },
      formStatsMaintStrategy: {
        dcrt: "", // date createed
        dedit: "", // last edit
        drev: "", // next review date (for critical documents)
        n: 0, // primary counter
        nctr: 0, // general counter
        nread: 0, // number of documents read
        nb3: 0, // actions
        nd4: 0, // number of attachments
        ng4: 0, // custondian for this equipment
        nk4: 0, // imported relelationships counters
        nm1: 0, // maintenance activity
        nm5: 0, // maintenance plans
        ns3: 0, // controls
        ns4: 0 // barriers
      },
      formStatsMaintPlan: {
        dcrt: "", // last created modified
        dcall: "", // last call due date
        dedit: "", // last edited
        drev: "", // next review date (for critical documents)
        ddue: "",
        nread: "",
        dcomp: "",
        dplan: "",
        dstr: "",
        dend: "",
        n: 0, // primary counter
        ndue: 0, // number of due date changes
        nedit: 0, // number if edits
        na1: 0, // asset regitse rcounter
        nk4: 0, // imported relelationships counters
        ng4: 0, // number of unqiue roles
        nl5: 0,
        nm7: 0, // maint call
        nh5: 0,
        no5: 0,
        ne5: 0,
        nw5: 0,
        nw6: 0, // number of procedure steps
        nb3: 0, // actions
        nd4: 0, // number of attachments
        ntrans: 0,
        nq1: 0, // number of orders parts
        nven: 0,
        nvenc: 0, // number of vendors mobilised
        ns1: 0,
        ns3: 0,
        ns4: 0,
        ns5: 0,
        uname: "", // first name and last name
        uemail: "",
        udid: "", // user did option
        upos: "", // user position
        ucom: "", // user comment
        uauth: "Org" // User author type, origninator is defaul
      },
      formStatsMaintCall: {
        dcrt: "", // last created modified
        ddue: "", // generated
        dcomp: "",
        dplan: "",
        dstr: "",
        dend: "",
        n: 0, // primary counter
        nread: "",
        ndue: 0, // number of due date changes
        nedit: 0, // number if edits
        na1: 0, // asset regitse counter
        nl5: 0, // parts
        nm7: 0, // pervious calls
        nh5: 0, // people
        no5: 0, // permits
        ne5: 0, // results
        nw5: 0, // tasks
        ns1: 0, // hazards
        uname: "", // first name and last name
        uemail: "",
        udid: "", // user did option
        upos: "", // user position
        ucom: "", // user comment
        uauth: "Org" // User author type, origninator is defaul
      },
      formStatsMaterial: {
        dcrt: "", // date createed
        dedit: "", // last edit
        drev: "", // next review date (for critical materials)
        n: 0, // primary counter
        nctr: 0, // general counter
        nread: 0, // number of documents read
        ndue: 0, // number of due date chnages
        nd4: 0, // number of attachments
        nk4: 0, // imported relelationships counters
        nl7: 0, // inventory
        nq1: 0, // number of orders
        nq1o: 0 // number of order open
      },
      formStatsProcedure: {
        dcrt: "", // date createed
        dedit: "", // last edit
        drev: "", // next review date (for critical documents)
        n: 0, // primary counter
        nctr: 0, // general counter
        nread: 0, // number of documents read
        nlike: 0, // number
        nd4: 0, // number of attachments
        nk4: 0, // imported relelationships counters
        ng4: 1, // number of roles (initial roles)
        nw5: 0 // tasks
      },
      formStatsProgram: {
        dcrt: "", // date createed
        dedit: "", // last edit
        drev: "", // next review date (for critical documents)
        n: 0, // primary counter
        nctr: 0, // general counter
        nread: 0, // number of documents read
        nlike: 0, // number
        nd4: 0, // number of attachments
        nk4: 0, // imported relelationships counters
        ng4: 1, // number of roles (initial roles)
        ne5: 0 // tasks
      },
      formStatsBudget: {
        dcrt: "", // date createed
        dedit: "", // last edit
        drev: "", // next review date (for critical documents)
        dstr: "", // budget plan start
        dend: "", // budgte plan end
        n: 0, // primary counter
        nctr: 0, // general counter
        nread: 0, // number of documents read
        nd4: 0, // number of attachments
        nk4: 0, // imported relelationships counters
        ng4: 1, // number of roles (initial roles)
        nq1: 0, // orders assigned to budget
        nq1o: 0 // order assigned to budte (currnetly open)
      },
      formStatsPlan: {
        dcrt: "", // date createed
        dedit: "", // last edit
        drev: "", // next review date (for critical documents)
        dstr: "", // budget plan start
        dend: "", // budgte plan end
        n: 0, // primary counter
        nctr: 0, // general counter
        nread: 0, // number of documents read
        nb7: 0, // business limits
        nd4: 0, // number of attachments
        nk4: 0, // imported relelationships counters
        ng4: 1, // number of roles (initial roles)
        nq1: 0, // orders assigned to budget
        nq1o: 0 // order assigned to budte (currnetly open)
      },
      formStatsGeneral: {
        devent: "", // date incident
        dvalid: "", // valid date
        drev: "", // next review date (for critical documents)
        dcont: "", // control date
        dmob: "", // mobilisaton date
        demob: "", // de mobilisation date
        dcrt: "", // date createed
        dread: "", // date ready or date when read
        dlast: "", // due date when is it due
        dlog: "", // last log date
        ddue: "", // due
        dcomp: "", // compliance date
        dplan: "", // plan date
        dedit: "",
        dexp: "", // expiry date
        dopen: "", // document opened
        dstr: "", // activity start
        dend: "", // activity end
        n: 0, // primary counter
        nctr: 0, // general counter
        ndue: 0, // number of due date chnages
        nover: 0, // number of overdue.somthing
        na1: 0, // number of assets
        nd4: 0, // number of attachments
        ne3: 0, // analysis / assessment
        ne5: 0, // results
        nf1: 0, // facility
        ng4: 0, // roles
        nk4: 0, // imported relelationships counters
        nb3: 0, // actions
        nb7: 0, // limit
        nl5: 0, // parts
        nm1: 0, // maint assurance
        nm5: 0, // maintenance
        nm7: 0, // maint calls
        no5: 0, // permits
        nh5: 0, // resurcs
        nw2: 0, // number of work requests generated
        nw5: 0, // tasks
        nw6: 0, // number of procedure steps
        uname: "", // first name and last name
        uemail: "",
        udid: "", // user did option
        upos: "", // user position
        ucom: "", // user comment
        uauth: "Org" // User author type, origninator is defaul
      }
    };
  }
};
